module.exports = "<div class=\"kuiToolBar\">\n  <button class=\"kuiButton kuiButton--basic\">\n    Basic button\n  </button>\n\n  <button disabled class=\"kuiButton kuiButton--basic\">\n    Basic button, disabled\n  </button>\n\n  <button class=\"kuiButton kuiButton--primary\">\n    Primary button\n  </button>\n\n  <button disabled class=\"kuiButton kuiButton--primary\">\n    Primary button, disabled\n  </button>\n\n  <button class=\"kuiButton kuiButton--danger\">\n    Danger button\n  </button>\n\n  <button disabled class=\"kuiButton kuiButton--danger\">\n    Danger button, disabled\n  </button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/button/buttons_in_tool_bar.html
 ** module id = 726
 ** module chunks = 0
 **/